<div class="toc-inner">
  <ul class="toc-list">
    @for (header of headers | async; track header) {
      <li>
        <a href="{{ buildURL(header.id) }}">{{ header.innerText }}</a>
      </li>
    }
  </ul>
</div>
